/* youthfulbloom — homepage behaviour. No dependencies; load with defer. */
(function () {
  'use strict';

  /* Card image track: keep dots in sync with scroll position */
  document.querySelectorAll('[data-yb-slides]').forEach(function (track) {
    var card = track.closest('[data-yb-card]');
    if (!card) return;
    var dots = card.querySelectorAll('[data-yb-dots] .yb-dot');
    if (dots.length < 2) return;
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      });
    }, { passive: true });
  });

  /* Wishlist — per browser only, so storage is wrapped in try/catch */
  var KEY = 'yb:wishlist';
  var saved = [];
  try { saved = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { saved = []; }
  if (!Array.isArray(saved)) saved = [];

  document.querySelectorAll('[data-yb-wish]').forEach(function (btn) {
    var handle = btn.getAttribute('data-yb-wish');
    if (saved.indexOf(handle) !== -1) btn.setAttribute('aria-pressed', 'true');
    btn.addEventListener('click', function () {
      var on = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', String(!on));
      var i = saved.indexOf(handle);
      if (on && i !== -1) saved.splice(i, 1);
      if (!on && i === -1) saved.push(handle);
      try { localStorage.setItem(KEY, JSON.stringify(saved)); } catch (e) {}
    });
  });

  /* Tabbed filter rails */
  document.querySelectorAll('[data-yb-tabs]').forEach(function (root) {
    var rail = root.querySelector('[data-yb-rail]');
    if (!rail) return;
    rail.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-yb-tab]');
      if (!tab) return;
      var id = tab.getAttribute('data-yb-tab');
      root.querySelectorAll('[data-yb-tab]').forEach(function (t) {
        t.setAttribute('aria-selected', String(t === tab));
      });
      root.querySelectorAll('[data-yb-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-yb-panel') !== id;
      });
      tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  });

  /* Quick add: post to cart without a page change */
  document.querySelectorAll('[data-yb-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('.yb-add');
      var original = btn ? btn.textContent : '+';
      if (btn) { btn.textContent = '·'; btn.disabled = true; }
      fetch(form.action, { method: 'POST', headers: { Accept: 'application/javascript' }, body: new FormData(form) })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () {
          if (btn) btn.textContent = '✓';
          document.dispatchEvent(new CustomEvent('yb:added'));
          var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
          if (bubble) bubble.textContent = String((parseInt(bubble.textContent, 10) || 0) + 1);
        })
        .catch(function () { if (btn) btn.textContent = '!'; })
        .then(function () {
          setTimeout(function () { if (btn) { btn.textContent = original || '+'; btn.disabled = false; } }, 1400);
        });
    });
  });
})();
